package com.neurobs.util

import io.circe.{Decoder, Encoder, Json}


/** Contains a GUID */
class Guid (val id: java.util.UUID) {
	/** Standard string representation in upper case without brackets */
	override def toString : String = id.toString().toUpperCase()

	/** Standard string representation in upper case without brackets */
	def noBracketsString : String = toString()

	/** Standard string representation in upper case with brackets {} */
	def bracketsString : String = s"{${noBracketsString}}"

	def lowercase: String = id.toString()

	override def equals(that: Any): Boolean =
		that match {
			case that: Guid => that.id.equals( this.id )
			case _ => false
		}

	override def hashCode: Int = {
		this.id.hashCode()
	}
}

/** Factory for Guid objects */
object Guid {
	val noBracketsStringSize = 36

	/** Creates Guid from a java UUID */
	def apply(id: java.util.UUID) : Guid = new Guid(id)

	/** Creates Guid from GUID string
		*
		* @param s GUID string in standard format, upper or lower case, with or without {}
		* @return None if invalid string, or Some(Guid) otherwise
		*/
	def apply(s: String) : Option[Guid] = {
		val trimmed = s.trim()
		val basic = if ( (trimmed.length >= 2) && (trimmed.charAt(0) == '{') ) trimmed.substring(1,trimmed.length - 1) else trimmed
		try {
			Some(Guid(java.util.UUID.fromString(basic)))
		}
		catch {
			case _: Exception => None
		}
	}

	/** Creates Guid object containing a random GUID */
	def generate: Guid = new Guid(java.util.UUID.randomUUID())

	/** Creates Guid filled with 0's */
	val nullGuid = new Guid(new java.util.UUID(0, 0))

	//implicit val GUIDEncoder: Encoder[Guid] = (a: Guid) => Json.fromString(a.toString)
	//implicit val circeOptionEncoder: Encoder[Option[Guid]] = (a: Option[Guid]) => Json.fromString(if (a.isDefined) a.get.toString else "")

	implicit val circeEncoder: Encoder[Guid] = (a: Guid) => io.circe.Json.fromString(a.noBracketsString)

	implicit val circeDecoder: Decoder[Guid] = (c: io.circe.HCursor) => c.as[String].map(i => Guid(i).get)
}